/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Content_Options_LabelInputs */

const en_transcript_export_content_options_label = /** @type {(inputs: Transcript_Export_Content_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content Options`)
};

const fr_transcript_export_content_options_label = /** @type {(inputs: Transcript_Export_Content_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options de contenu`)
};

const de_transcript_export_content_options_label = /** @type {(inputs: Transcript_Export_Content_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inhaltsoptionen`)
};

const it_transcript_export_content_options_label = /** @type {(inputs: Transcript_Export_Content_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzioni di contenuto`)
};

const ru_transcript_export_content_options_label = /** @type {(inputs: Transcript_Export_Content_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Параметры содержимого`)
};

const es_transcript_export_content_options_label = /** @type {(inputs: Transcript_Export_Content_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opciones de contenido`)
};

const zh_cn2_transcript_export_content_options_label = /** @type {(inputs: Transcript_Export_Content_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内容选项`)
};

const ja_transcript_export_content_options_label = /** @type {(inputs: Transcript_Export_Content_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コンテンツオプション`)
};

const hi_transcript_export_content_options_label = /** @type {(inputs: Transcript_Export_Content_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सामग्री विकल्प`)
};

const pt_pt2_transcript_export_content_options_label = /** @type {(inputs: Transcript_Export_Content_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opções de conteúdo`)
};

/**
* | output |
* | --- |
* | "Content Options" |
*
* @param {Transcript_Export_Content_Options_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_content_options_label = /** @type {((inputs?: Transcript_Export_Content_Options_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Content_Options_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_content_options_label(inputs)
	if (locale === "de") return de_transcript_export_content_options_label(inputs)
	if (locale === "it") return it_transcript_export_content_options_label(inputs)
	if (locale === "ru") return ru_transcript_export_content_options_label(inputs)
	if (locale === "es") return es_transcript_export_content_options_label(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_content_options_label(inputs)
	if (locale === "ja") return ja_transcript_export_content_options_label(inputs)
	if (locale === "hi") return hi_transcript_export_content_options_label(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_content_options_label(inputs)
	return en_transcript_export_content_options_label(inputs)
});